import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getAnalytics } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

function assertConfig(config) {
  Object.entries(config).forEach(([key, value]) => {
    if (!value) {
      throw new Error(`Missing Firebase environment variable: ${key}`);
    }
  });
}

assertConfig(firebaseConfig);

export const firebaseApp = initializeApp(firebaseConfig);
export const firebaseAuth = getAuth(firebaseApp);

let analyticsInstance = null;
if (typeof window !== 'undefined') {
  if (process.env.NODE_ENV === 'development') {
    window.firebaseAuth = firebaseAuth;
  }
  try {
    analyticsInstance = getAnalytics(firebaseApp);
  } catch (_err) {
    // analytics is optional; ignore runtime failures (e.g. unsupported envs)
    analyticsInstance = null;
  }
}

export const firebaseAnalytics = analyticsInstance;
